// extracted by mini-css-extract-plugin
export var modal = "_mm-0";